import { useSearchParams } from 'react-router-dom';

import { regionSlugFromParam } from '../../primitives/scope/region-param';
import { useOwnRegions } from '../../primitives/scope/use-own-regions';

export interface VenuesRegionScope {
  /** Nothing is chosen yet; show the spinner, not national data. */
  pending: boolean;
  /** Region slugs to ask the roster for. Empty is every region. */
  regions: string[];
  /** The viewer needs a region to be scoped to and has none, so they see everything. */
  noRegions: boolean;
}

/**
 * Which regions the Venues page reports on.
 *
 * The address wins: `?region=<slug>` is that region and `?region=all` is every
 * region, on purpose. With neither, a viewer without read:all who has assigned
 * regions opens on the union of them, and everyone else opens national.
 */
export function useVenuesRegionScope(): VenuesRegionScope {
  const [params] = useSearchParams();
  const named = params.get('region');
  const { pending, own, noRegions } = useOwnRegions();

  if (named !== null) {
    const slug = regionSlugFromParam(named);
    return { pending: false, regions: slug ? [slug] : [], noRegions: false };
  }
  if (pending) return { pending: true, regions: [], noRegions: false };
  return { pending: false, regions: own.map((r) => r.slug), noRegions: !!noRegions };
}
